export const adminEmail = 'jewishbookcorner@gmail.com';
